import React from 'react';
import PropTypes from 'prop-types';
// Core components
import List from 'components/core/List';
// Custom
import { companyDataShape } from 'constants/PropTypesShapes';
import CollapseBoxTemplate from 'components/templates/CollapseBoxTemplate';
import CompanyChildItem from './CompanyChildItem';

const CompanyItem = ({
  company, withActions, withSelection, selectedId, onAdd, onDelete, onSelect, withChildItem,
}) => (
  <CollapseBoxTemplate
    title={`${company.name}`}
    titleSize="sm"
  >
    <div>
      <List>
        <CompanyChildItem
          company={company}
          withActions={withActions}
          withSelection={withSelection}
          selectedId={selectedId}
          onAdd={onAdd}
          onDelete={onDelete}
          onSelect={onSelect}
          level={0}
          withChildItem={withChildItem}
        />
      </List>
    </div>
  </CollapseBoxTemplate>
);

CompanyItem.propTypes = {
  company: companyDataShape.isRequired,
  withActions: PropTypes.bool,
  withSelection: PropTypes.bool,
  selectedId: PropTypes.number,
  onAdd: PropTypes.func,
  onDelete: PropTypes.func,
  onSelect: PropTypes.func,
  withChildItem: PropTypes.bool,
};

CompanyItem.defaultProps = {
  withActions: false,
  withSelection: false,
  selectedId: null,
  onAdd: null,
  onDelete: null,
  onSelect: null,
  withChildItem: false,
};

module.exports = CompanyItem;



// WEBPACK FOOTER //
// ./routes/app/routes/companies/assets/main/CompanyItem.js